var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/client.ts
import { useMemo } from "react";
import { useAuthUrl } from "@propelauth/react";
import { createFrontendApisClient } from "@propelauth/frontend-apis";
var useAuthFrontendApis = () => {
  const authUrl = useAuthUrl();
  return useMemo(() => {
    return createFrontendApisClient({ authUrl, baseApiUrl: authUrl });
  }, [authUrl]);
};

// src/hooks/useMfa.tsx
import { useEffect, useState } from "react";
var MfaStatus = /* @__PURE__ */ ((MfaStatus2) => {
  MfaStatus2["Loading"] = "loading";
  MfaStatus2["Disabled"] = "disabled";
  MfaStatus2["Enabled"] = "enabled";
  MfaStatus2["UnexpectedError"] = "unexpected_error";
  return MfaStatus2;
})(MfaStatus || {});
var useMfa = () => {
  const { enableMfa, disableMfa, fetchMfaStatusWithNewSecret } = useAuthFrontendApis();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(void 0);
  const [response, setResponse] = useState(void 0);
  const reloadMfaStatus = () => __async(void 0, null, function* () {
    setError(void 0);
    setIsLoading(true);
    fetchMfaStatusWithNewSecret().then((response2) => __async(void 0, null, function* () {
      yield response2.handle({
        success: (response3) => {
          setResponse(response3);
        },
        unexpectedOrUnhandled(error2) {
          setError(error2);
        }
      });
    })).finally(() => {
      setIsLoading(false);
    });
  });
  useEffect(() => {
    reloadMfaStatus();
  }, []);
  if (isLoading) {
    return {
      status: "loading" /* Loading */,
      reloadMfaStatus,
      data: void 0,
      enableMfa: void 0,
      disableMfa: void 0
    };
  } else if (error || !response) {
    return {
      status: "unexpected_error" /* UnexpectedError */,
      reloadMfaStatus,
      data: void 0,
      enableMfa: void 0,
      disableMfa: void 0
    };
  } else if (!response.mfa_enabled) {
    return {
      status: "disabled" /* Disabled */,
      reloadMfaStatus,
      data: response,
      enableMfa,
      disableMfa: void 0
    };
  } else {
    return {
      status: "enabled" /* Enabled */,
      reloadMfaStatus,
      data: response,
      enableMfa: void 0,
      disableMfa
    };
  }
};

// src/hooks/usePaginationWithSearch.tsx
import { useEffect as useEffect2, useState as useState2 } from "react";
var DEFAULT_DEBOUNCE_MS = 500;
var usePaginationWithSearch = ({ debounceMs = DEFAULT_DEBOUNCE_MS }) => {
  const [search, setSearch] = useState2("");
  const [debouncedSearch, setDebouncedSearch] = useState2("");
  const [page, setPage] = useState2(0);
  useEffect2(() => {
    const delayInputTimeoutId = setTimeout(() => {
      setDebouncedSearch(search);
    }, debounceMs);
    return () => clearTimeout(delayInputTimeoutId);
  }, [search]);
  useEffect2(() => {
    setPage(0);
  }, [search]);
  const nextPage = () => {
    setPage((prev) => prev + 1);
  };
  const previousPage = () => {
    setPage((prev) => prev - 1);
  };
  return { search, setSearch, debouncedSearch, page, nextPage, previousPage };
};
export {
  MfaStatus,
  useAuthFrontendApis,
  useMfa,
  usePaginationWithSearch
};
//# sourceMappingURL=index.mjs.map